import slugify from "slugify";
import { customAlphabet } from "nanoid";
import { NANOID_LENGTH } from "../constants/general.constants";
import { v4 as uuid } from "uuid";

const NANOID_CHARACTERSET =
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const nanoid = customAlphabet(NANOID_CHARACTERSET, NANOID_LENGTH);

// All tags except process tag should have '_' (underscore) as separator. Process tag should have '-' (hyphen) as separator.
export const getSlugifiedTag = (name: string, separator: string = "_") =>
  slugify(name.trim().replace(/[\W_]+/g, " "), separator).toLowerCase();

export const getNanoId = () => {
  return nanoid();
};

export const getUUID = () => {
  return uuid();
};

export const nanoIdWithProcessId = (processId: string): string => {
  const nanoId = getNanoId();
  return `${processId}__${nanoId}`;
};
